import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { CapturumCalendarComponent } from '@capturum/ui/calendar';
import { ManageValidatorDisplayDirective } from '@features/client/form-builder/directives/hide-validator.directive';
import { FormTooltipComponent } from '@shared/components/form-tooltip/form-tooltip.component';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  imports: [CapturumCalendarComponent, ManageValidatorDisplayDirective, FormTooltipComponent, ReactiveFormsModule],
})
export class DateInputComponent extends FieldType {}
